import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { useFormContext, useFormShowContext } from 'framework/form';

interface Props {
  onCancel: () => void;
}

const FormButtons: FC<Props> = ({ onCancel }) => {
  const { submitForm, isSubmitEnabled } = useFormContext();
  const { isEditMode } = useFormShowContext();
  if (!isEditMode) return null;
  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2}>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" disabled={!isSubmitEnabled} onClick={() => submitForm?.()}>
        Transfer data
      </Button>
    </Stack>
  );
};

export default FormButtons;
